import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';
import { toast } from 'react-toastify';
import CollegeLogo from '../components/images/College_logo.png';

const ForgotPassword = () => {
    const navigate = useNavigate();

    // --- STATE ---
    const [step, setStep] = useState(1); // 1 = Enter Email, 2 = Enter OTP & New Pass
    const [identifier, setIdentifier] = useState('');

    // Step 2 Data
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);

    // Hosted vs Local View
    const [showStaticView, setShowStaticView] = useState(false);

    // --- STEP 1: SEND OTP ---
    const handleSendOTP = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // 1. Ask backend for OTP
            const { data } = await API.post('/auth/forgot-password', { identifier });
            toast.success(data.message); // "OTP Sent"

            // 2. Move to Step 2
            setStep(2);
        } catch (error) {
            // If backend says 503, it means Email is Disabled (Hosted Mode)
            if (error.response && error.response.status === 503) {
                setShowStaticView(true);
            } else {
                toast.error(error.response?.data?.message || 'Error sending request');
            }
        }
        setLoading(false);
    };

    // --- STEP 2: VERIFY & RESET ---
    const handleFinalReset = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await API.post('/auth/reset-password', {
                identifier,
                otp,
                newPassword
            });
            toast.success("✅ Password Changed! Please Login.");
            navigate('/'); // Redirect to Login
        } catch (error) {
            toast.error(error.response?.data?.message || 'Reset Failed');
        }
        setLoading(false);
    };

    return (
        <div style={{
            display: 'flex', height: '100vh', width: '100vw',
            alignItems: 'center', justifyContent: 'center',
            backgroundColor: 'var(--bg-body)', padding: '1rem'
        }}>
            <div className="card" style={{
                width: '100%', maxWidth: '450px', textAlign: 'center',
                padding: '3rem 2rem', boxShadow: 'var(--shadow-lg)'
            }}>
                <img src={CollegeLogo} alt="Logo" style={{ height: '60px', marginBottom: '1rem', objectFit: 'contain' }} />

                <div style={{
                    fontSize: '3rem', marginBottom: '1rem', background: 'var(--bg-body)',
                    width: '80px', height: '80px', lineHeight: '80px', borderRadius: '50%',
                    margin: '0 auto 1.5rem auto'
                }}>
                    <span className="notranslate">🔒</span>
                </div>

                {/* --- VIEW 1: CONTACT ADMIN (Hosted Mode) --- */}
                {showStaticView ? (
                    <div className="animate-fade-in">
                        <h2 style={{ marginBottom: '1rem', color: 'var(--text-main)' }}>Contact Administrator</h2>
                        <p style={{ color: 'var(--text-muted)', lineHeight: '1.6', marginBottom: '2rem' }}>
                            Automatic password reset is disabled on this server.
                            <br />
                            Please visit the <strong>Circulation Desk</strong> to reset your password.
                        </p>
                    </div>
                ) : (
                    /* --- LOCAL MODE FLOW --- */
                    <>
                        {step === 1 && (
                            <div className="animate-fade-in">
                                <h2 style={{ marginBottom: '1rem', color: 'var(--text-main)' }}>Reset Password</h2>
                                <p style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>
                                    Enter your Email or Register Number to receive an OTP.
                                </p>
                                <form onSubmit={handleSendOTP}>
                                    <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Email or Reg No..."
                                            value={identifier}
                                            onChange={e => setIdentifier(e.target.value)}
                                            required
                                            autoFocus
                                        />
                                    </div>
                                    <button className="btn btn-primary" style={{ width: '100%', padding: '12px' }} disabled={loading}>
                                        {loading ? 'Processing...' : 'Send OTP Code'}
                                    </button>
                                </form>
                            </div>
                        )}

                        {step === 2 && (
                            <div className="animate-fade-in">
                                <h2 style={{ marginBottom: '1rem', color: 'var(--text-main)' }}>Enter New Password</h2>
                                <p style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>
                                    An OTP has been sent to your email.
                                </p>
                                <form onSubmit={handleFinalReset}>
                                    <div className="form-group" style={{ marginBottom: '1rem' }}>
                                        <label style={{ display: 'block', textAlign: 'left', marginBottom: '5px' }}>Enter OTP</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="6-digit Code"
                                            value={otp}
                                            onChange={e => setOtp(e.target.value)}
                                            required
                                            style={{ letterSpacing: '5px', textAlign: 'center', fontSize: '1.2rem' }}
                                        />
                                    </div>
                                    <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                                        <label style={{ display: 'block', textAlign: 'left', marginBottom: '5px' }}>New Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            placeholder="Min 6 characters"
                                            value={newPassword}
                                            onChange={e => setNewPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <button className="btn btn-primary" style={{ width: '100%', padding: '12px' }} disabled={loading}>
                                        {loading ? 'Resetting...' : 'Change Password'}
                                    </button>
                                </form>
                            </div>
                        )}
                    </>
                )}

                <button
                    onClick={() => navigate('/')}
                    className="btn btn-secondary"
                    style={{ width: '100%', marginTop: '1rem', border: 'none', background: 'transparent' }}
                >
                    ← Back to Login
                </button>
            </div>
        </div>
    );
};

export default ForgotPassword;